export default {
      id: "arrow-alt-left-usage",
      viewBox: "0 0 5 8",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#arrow-alt-left",
      toString: function () {
        return this.url;
      }
    }